export enum JobLinkedinPlacement {
    SponsoredUpdates = 'sponsored_updates',
}

export const getJobLinkedinPlacementDisplayName = (linkedinPlacement: JobLinkedinPlacement): string => {
    switch (linkedinPlacement) {
        case JobLinkedinPlacement.SponsoredUpdates:
            return 'Sponsored Updates';
    }
};
